import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/cashwheel/pddv2_top_money.png'
import _imports_1 from '@/assets/cashwheel/pddv2_pop_btn_com.png'


const _hoisted_1 = { class: "pop_content" }
const _hoisted_2 = { class: "money_amount" }
const _hoisted_3 = { class: "amount_text" }
const _hoisted_4 = { class: "paymeny_method" }

import { ref, watch } from 'vue'
import ShareContent from './shareContent.vue'
import { formatCurrency } from '@/utils/commonFunction'

export default /*@__PURE__*/_defineComponent({
  __name: 'paymentPopup',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const sharePopupRef = ref()
const animatedValue = ref(0)
const resData = ref()
const open = (data: any) => {
    show.value = true
    resData.value = data

    const target = resData.value.user_pdd_info.current_progress / 100
    animateValue(0, target, 800)
}
const close = () => {
    show.value = false
}
const showSharePopup = () => {
    sharePopupRef.value.open()
}
const animateValue = (start: number, end: number, duration: number) => {
    const startTime = performance.now()

    const step = (currentTime: number) => {
        const progress = Math.min((currentTime - startTime) / duration, 1)
        animatedValue.value = start + (end - start) * progress

        if (progress < 1) {
            requestAnimationFrame(step)
        } else {
            animatedValue.value = end
        }
    }

    requestAnimationFrame(step)
}

__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      round: "",
      "overlay-style": { overflow: 'hidden' },
      style: {
        width: '80%',
        Height: '50%',
        background: '#27190D',
        borderRadius: '30px'
    }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_row, { class: "popup_head" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "20",
              offset: "2",
              class: "alignements"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode(" Em breve poderá sacar ")
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "2",
              class: "alignements"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "close_icon alignements",
                  onClick: close
                }, [
                  _createVNode(_component_van_icon, { name: "cross" })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "total_text" }, "Total de dinheiro a ser pago em breve", -1)),
          _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(formatCurrency)(animatedValue.value)), 1),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "currency_text" }, "BTC", -1))
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text1" }, "Formas de Pagamentos", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_steps, {
              direction: "vertical",
              active: 1,
              "finish-icon": "success",
              "active-iconfinish-icon": "success"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_step, null, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("div", null, "O pedido de pagamento foi submetido", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_step, null, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("div", null, "Ainda é necessário 4.28 para realizar o saque", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_step, null, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("div", null, "100 R$ serão pagos na sua conta Pix", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", { class: "btn_container" }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "",
              onClick: showSharePopup
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(ShareContent, {
      ref_key: "sharePopupRef",
      ref: sharePopupRef
    }, null, 512)
  ], 64))
}
}

})